// Full updated code implementing functionality separation between Add Items (Tab 1) and Pay Purchased Items (Tab 2) with delete icon for Tab 2 and styling improvements

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Typography,
  Checkbox,
  Button,
  TextField,
  Grid,
  IconButton,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const IndividualStudentsBooksList = () => {
  const { userId, oId, pId } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { Class, studentId, fullName } = useParams();
  const [firstName, lastName] = fullName.split("_");

  const [activeTab, setActiveTab] = useState(0);
  const [itemsTableData, setItemsTableData] = useState([]);
  const [purchasedItems, setPurchasedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
   const [addedItems, setAddedItems] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
   const [dialogBtnLoading, setDialogbtnloading] = useState(false);


useEffect(() => {
  const tabFromSession = sessionStorage.getItem("activeTab");

  if (tabFromSession !== null) {
    setActiveTab(parseInt(tabFromSession));
    sessionStorage.removeItem("activeTab"); // optional cleanup
    fetchInvoiceData();
  }
}, []);


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (newValue === 1) fetchPurchasedItems();
    if (newValue === 2) fetchInvoiceData();
  };

  //tab 0 get api
  const fetchItemsTableData = async () => {
    if (!Class) return;
    setTableLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/additionalFee/getAll/${pId}/${Class}`);
      const data = await response.json();
    if (response.ok && Array.isArray(data)) {
            setItemsTableData(data);
            setSelectedItems(data);
          } else {
            setItemsTableData([]);
            setSelectedItems([]);
          }



    } catch (error) {
      console.error("Error loading class table:", error);
      setItemsTableData([]);
      setSelectedItems([]);
    } finally {
      setTableLoading(false);
    }
  };
    useEffect(() => {
    fetchItemsTableData();
  }, [pId, Class]);

   //tab 1 get api
//   const fetchPurchasedItems = async () => {
//     if (!studentId) return;
//     try {
//       const response = await fetch(`${baseUrl}/api/studentPurchaseItem/getStudentPurchaseRequests/${studentId}`);
//       const data = await response.json();

// if (response.ok && Array.isArray(data)) {
//             setPurchasedItems(data);
//             setAddedItems(data);
//           } else {
//             setPurchasedItems([]);
//             setAddedItems([]);
//           }



//     } catch (err) {
//       console.error("Error fetching purchased items", err);
//       setPurchasedItems([]);
//     }
//   };

const fetchPurchasedItems = async () => {
  if (!studentId) return;
  try {
    const response = await fetch(`${baseUrl}/api/studentPurchaseItem/getStudentPurchaseRequests/${studentId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const normalizedData = data.map(item => ({
        ...item,
        qty: item.qty ?? 1, // default to 1 or 0 if qty is missing
      }));

      setPurchasedItems(normalizedData);
      setAddedItems(normalizedData);
    } else {
      setPurchasedItems([]);
      setAddedItems([]);
    }
  } catch (err) {
    console.error("Error fetching purchased items", err);
    setPurchasedItems([]);
    setAddedItems([]);
  }
};


 //tab 2 get api
const fetchInvoiceData = async () => {
    if (!studentId) return;
    try {
      const response = await fetch(`${baseUrl}/api/studentSoldItems/getInvoiceSummaryByStudentId/${studentId}`);
      const data = await response.json();

if (response.ok && Array.isArray(data)) {
            setPurchasedItems(data);
          } else {
            setPurchasedItems([]);
          }



    } catch (err) {
      console.error("Error fetching Sold items", err);
      setPurchasedItems([]);
    }
  };



  const handleCheckboxChange = (item) => {
    const exists = selectedItems.some((i) => i.id === item.id);
    if (exists) setSelectedItems((prev) => prev.filter((i) => i.id !== item.id));
    else setSelectedItems((prev) => [...prev, { ...item, qty: 1, totalAmount: item.pricePerItemAmount }]);
  };



const handleAddItems = async () => {
  if (selectedItems.length === 0) {
    toast.warning("Select at least one item.", {
      autoClose: 2000,
    });
    return;
  }

  try {
    setIsProcessing(true);

    const response = await fetch(
      `${baseUrl}/api/studentPurchaseItem/saveStudentsItems/${studentId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(selectedItems),
      }
    );

    if (response.ok) {
      toast.success("Items added successfully!", {
        autoClose: 1000,
      });
      fetchPurchasedItems();
      setActiveTab(1); // Switch to Tab 2
    } else {
      // Attempt to read error message from response
      const errorText = await response.text();
      const errorMessage = errorText || "Failed to add items.";

      toast.error(errorMessage, {
        autoClose: 2000,
      });
    }
  } catch (error) {
    toast.error("Add item request failed. Please try again.", {
      autoClose: 2000,
    });
    console.error("Add items error:", error);
  } finally {
    setIsProcessing(false);
  }
};


  const handleQtyChange = (index, newQty) => {
    if (/^\d+$/.test(newQty) && Number(newQty) > 0) {
      const updated = [...purchasedItems];
      updated[index].qty = Number(newQty);
      updated[index].totalAmount = Number(newQty) * updated[index].pricePerItemAmount;
      setPurchasedItems(updated);
    }
  };





const handleSaveChanges = async (currentItem) => {
    const itemToSave = selectedRow?.id === currentItem.id ? selectedRow : { ...currentItem };
    if (!itemToSave.id) {
      toast.error("Cannot save: missing item ID.");
      return;
    }

    setDialogbtnloading(true);
    try {
      const formData = new FormData();
      Object.keys(itemToSave).forEach((key) => {
        if (itemToSave[key] !== null && itemToSave[key] !== undefined) {
          formData.append(key, itemToSave[key]);
        }
      });

      const response = await fetch(
        `${baseUrl}/api/studentPurchaseItem/updateStudentPurchaseRequest/${itemToSave.id}`,
        {
          method: "PATCH",
          body: formData,
        }
      );

      const responseData = await response.text();

      if (response.ok) {
        toast.success(`Quantity "${itemToSave.qty}" updated successfully!`, {
          autoClose: 1000, // 1 second
        });
        fetchPurchasedItems();
        // setSelectedRow(null);
      } else {
        toast.error(responseData || "Failed to update Quantity.", {
        autoClose: 2000, // 2 seconds
        });
      }
    } catch (error) {
      toast.error(`Error updating details: ${error}`, {
        autoClose: 2000, // 2 seconds
      });
    } finally {
      setDialogbtnloading(false);
    }
  };



const handlePurchasedPay = async () => {
  if (purchasedItems.length === 0) {
    toast.warning("No items to pay for.", { autoClose: 2000 });
    return;
  }

  const itemNamesList = purchasedItems.map((item) => item.itemNames);
  const priceList = purchasedItems.map((item) => Number(item.pricePerItemAmount));
  const qtyList = purchasedItems.map((item) => Number(item.qty));
  const totalAmountList = purchasedItems.map((item) => Number(item.totalAmount));

  const itemNamesPreview = itemNamesList.join(", ");

  const confirmResult = await Swal.fire({
    title: "Confirm Payment",
    html: `<strong>Selected Items:</strong> ${itemNamesPreview}<br/><strong>Total Amount:</strong> ₹${totalAmount}`,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Pay Now",
    cancelButtonText: "Cancel",
  });

  if (confirmResult.isConfirmed) {
    try {
      setIsProcessing(true);

      const payload = {
        studentId,
        itemNames: itemNamesList,
        pricePerItemAmount: priceList,
        qty: qtyList,
        totalAmount: totalAmountList,
      };

      const response = await fetch(
        `${baseUrl}/api/studentSoldItems/saveMultipleSoldItems/${oId}/${pId}/${studentId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        toast.success("Payment successful!", { autoClose: 1000 });
        fetchPurchasedItems(); // optional: refresh list after payment
        fetchInvoiceData();
        setActiveTab(2);
      } else {
        const errorText = await response.text();
        toast.error(`Payment failed: ${errorText}`, { autoClose: 2000 });
      }
    } catch (err) {
      toast.error(`Payment error: ${err.message}`, { autoClose: 2000 });
    } finally {
      setIsProcessing(false);
    }
  }
};



const handleDeleteItem = async (row) => {
  const confirm = await Swal.fire({
    title: "Are you sure?",
    html: `You want to delete Item:<strong> ${row.itemNames}</strong> `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) return;

  try {
    const response = await fetch(`${baseUrl}/api/studentPurchaseItem/delete/${row.id}`, {
      method: "DELETE",
    });



    if (response.ok) {
      setPurchasedItems((prev) => prev.filter((item) => item.id !== row.id));
      toast.success("Item deleted successfully!", { autoClose: 1000 });
    } else {
      const errorText = await response.text();
      toast.error(`Failed to delete item: ${errorText}`, { autoClose: 2000 });
    }
  } catch (error) {
    toast.error(`Error deleting item: ${error}`, { autoClose: 2000 });
  }
};













  const totalAmount = activeTab === 0
    ? selectedItems.reduce((acc, item) => acc + (item.totalAmount || 0), 0)
    : purchasedItems.reduce((acc, item) => acc + (item.totalAmount || 0), 0);

  const dataToShow = activeTab === 0 ? itemsTableData : purchasedItems;

  return (
    <Box sx={{ margin: "5% 1% 1% 1%" }}>
      <Card sx={{ padding: 3, borderRadius: 3, boxShadow: 3 }}>
        <Box display="flex" alignItems="center" sx={{ pb: 1 }}>
          <IconButton onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon />
          </IconButton>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            <span style={{ color: "#757575", fontSize: "18px" }}>
              {`${firstName} ${lastName}`}
            </span>{" "}
            -{" "}
            {activeTab === 0
              ? "Additional Items"
              : activeTab === 1
              ? "Added Items"
              : "Bill Summary"}
          </Typography>

        </Box>

        {/* <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
          <Tab label="Stationery Items" />
          <Tab label="Added Items" />
          <Tab label="Bill Summary" />
        </Tabs> */}
        <StyledTabs activeTab={activeTab} handleTabChange={handleTabChange} />


         <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin",
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey",
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

  <TableContainer
      component={Paper}
      style={{
        marginTop: "20px",
        borderRadius: "8px",
        maxHeight: "350px",
        overflow: "auto",
      }}
      className="custom-sidebar-scrollbar"
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerCellStyle}>Sl No</TableCell>
            {activeTab === 2 && (<TableCell sx={headerCellStyle}>Bill Date</TableCell>)}
            <TableCell sx={headerCellStyle}>
              {activeTab === 2 ? "Bill No" : "Item Name"}
            </TableCell>
            {activeTab === 1 && <TableCell sx={headerCellStyle}>Quantity</TableCell>}
           {(activeTab === 0 || activeTab === 1) &&  <TableCell sx={headerCellStyle}>Price (₹)</TableCell>}
            <TableCell sx={headerCellStyle}>{activeTab === 2 ? "Grand Total (₹)" : "Total (₹)"}</TableCell>
            {(activeTab === 1 || activeTab === 2) && <TableCell sx={headerCellStyle}>Action</TableCell>}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableLoading ? (
            <TableRow>
              <TableCell colSpan={activeTab === 1 ? 6 : 5} align="center">
                <CircularProgress />
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Loading Data...
                </Typography>
              </TableCell>
            </TableRow>
          ) : dataToShow.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={activeTab === 1 ? 6 : 5}
                sx={{ textAlign: "center", py: 3 }}
              >
                <Typography variant="body1" fontWeight="bold">
                  {activeTab === 2 ? "No Invoices found " : "No Items found"}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            dataToShow.map((row, index) => {
              if (!row) return null;

              const isSelected = selectedItems.some((i) => i.id === row.id);

              return (
                <TableRow key={row.id}>
                  <TableCell sx={cellStyle}>{index + 1}</TableCell>

                  <TableCell sx={cellStyle}>
                    {activeTab === 0 ? (
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleCheckboxChange(row)}
                          color="primary"
                          sx={{ padding: 1, marginRight: 1 }}
                        />
                        <Typography variant="body2">{row.itemNames}</Typography>
                      </Box>
                    ) : (
                      <Typography variant="body2" textAlign="center" width="100%">
                        {activeTab === 2 ? `${row.soldDate}` : `${row.itemNames}`}
                      </Typography>
                    )}
                  </TableCell>

                  {activeTab === 1 && (
                  <TableCell sx={cellStyle}>
  {row && typeof row.qty !== "undefined" ? (
    // <TextField
    //   type="number"
    //   variant="outlined"
    //   size="small"
    //   value={
    //     selectedRow?.id === row.id && typeof selectedRow.qty !== "undefined"
    //       ? selectedRow.qty
    //       : row.qty
    //   }
    //   onChange={(e) => {
    //     const newQty = e.target.value;
    //     if (/^\d*$/.test(newQty)) {
    //       setSelectedRow({ ...row, qty: newQty });
    //     }
    //   }}
    //   onBlur={() => handleSaveChanges(row)}
    //   onKeyDown={(e) => {
    //     if (e.key === "Enter") e.target.blur();
    //   }}
    //   inputProps={{
    //     style: { textAlign: "center" },
    //     min: 1,
    //   }}
    //   sx={{
    //     width: "110px",
    //     input: {
    //       height: "35px",
    //       fontWeight: "bold",
    //       color: "gray",
    //       padding: "2px",
    //     },
    //   }}
    // />
    <TextField
  type="text" // ✅ use text to prevent browser allowing e, -, + etc.
  variant="outlined"
  size="small"
  value={
    selectedRow?.id === row.id && typeof selectedRow.qty !== "undefined"
      ? selectedRow.qty
      : row.qty
  }
  onChange={(e) => {
    const newQty = e.target.value;
    // ✅ allow only digits (0–9)
    if (/^\d*$/.test(newQty)) {
      setSelectedRow({ ...row, qty: newQty });
    }
  }}
  onBlur={() => handleSaveChanges(row)}
  onKeyDown={(e) => {
    // ✅ prevent typing unwanted characters
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") e.target.blur();
  }}
  inputProps={{
    style: { textAlign: "center" },
    inputMode: "numeric", // ✅ mobile keyboards show numbers
  }}
  sx={{
    width: "110px",
    input: {
      height: "35px",
      fontWeight: "bold",
      color: "gray",
      padding: "2px",
    },
  }}
/>

  ) : (
    "-"
  )}
</TableCell>

                  )}
                 {activeTab === 2 && ( <TableCell sx={cellStyle}>{row.invoiceNo}</TableCell>)}

                  {(activeTab === 0 || activeTab === 1) && <TableCell sx={cellStyle}>₹{row.pricePerItemAmount}</TableCell>}
                  <TableCell sx={cellStyle}>
                    {/* ₹{row.totalAmount} */}
                      ₹{activeTab === 2 ? `${row.finalAmount}` : `${row.totalAmount}`}
                    </TableCell>
                  {activeTab === 2 && ( <TableCell sx={cellStyle} style={{padding:'8px'}}>
                 <Button
                                          type="button"
                                          onClick={() => {
                                            sessionStorage.setItem("soldItemData", JSON.stringify(row));
                                            navigate(`/BooksReceipt/${row.invoiceNo}`);
                                          }}

                                          sx={{
                                            backgroundColor: "#1976d2",
                                            color: "white",
                                            fontSize: "0.6rem", // Reduces the font size
                                            fontWeight:'bold',
                                            height: "25px", // Reduces the height
                                            "&:hover": {
                                              backgroundColor: "#1565c0",
                                            },
                                          }}
                                        >
                                          Bill Receipt
                                        </Button>
                    
                    
                    </TableCell>)}

                  {activeTab === 1 && (
                    <TableCell sx={cellStyle}>
                      <IconButton color="error" onClick={() => handleDeleteItem(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>






 {(activeTab === 0 || activeTab === 1) && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
             <Typography variant="h6">
                  Total Selected Items Amount: <strong>₹{totalAmount}</strong>
                </Typography>
          </Grid>
          {/* <Grid item xs={12} sm={6} textAlign="right">
            <Button
              variant="contained"
              color="success"
              onClick={activeTab === 0 ? handleAddItems : handlePurchasedPay}
              disabled={isProcessing || (activeTab === 0 && selectedItems.length === 0) || (activeTab === 1 && addedItems.length === 0)}
            >
              {activeTab === 0 ? `Add Items` : `Pay ₹${totalAmount}`}
            </Button>
          </Grid> */}
          <Grid item xs={12} sm={6} textAlign="right">
  <Button
    variant="contained"
    color="success"
    onClick={activeTab === 0 ? handleAddItems : handlePurchasedPay}
    disabled={
      isProcessing ||
      (activeTab === 0 && selectedItems.length === 0) ||
      (activeTab === 1 && addedItems.length === 0)
    }
    sx={{
      px: 4,
      py: 1.5,
      fontSize: "16px",
      fontWeight: "bold",
      borderRadius: "12px",
      letterSpacing: "0.8px",
      boxShadow: "0px 4px 12px rgba(0, 128, 0, 0.3)",
      transition: "all 0.3s ease",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#2e7d32",
        boxShadow: "0px 6px 16px rgba(0, 128, 0, 0.4)",
      },
      "&:disabled": {
        backgroundColor: "#c8e6c9",
        color: "#888",
        boxShadow: "none",
      },
    }}
    startIcon={activeTab === 0 ? "➕" : "💰"}
  >
    {activeTab === 0 ? "Add Items" : `Pay ₹${totalAmount}`}
  </Button>
</Grid>

        </Grid>
)}
      </Card>
      <ToastContainer />
    </Box>
  );
};


const StyledTabs = ({ activeTab, handleTabChange }) => {
  return (
    <Box
      sx={{
        // bgcolor: "white",
        borderRadius: 2,
        // boxShadow: 3,
        px: 2,
        py: 1,
        mb: 3,
        width: "fit-content", // Only as wide as needed
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        orientation="horizontal"
        TabIndicatorProps={{
          style: {
            height: "4px",
            borderRadius: "4px",
            backgroundColor: "#1976d2",
            transition: "all 0.3s ease",
          },
        }}
        sx={{
          ".MuiTab-root": {
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "15px",
            color: "#555",
            borderRadius: "8px",
            minHeight: "48px",
            px: 3,
            mr: 1.5,
            transition: "0.3s",
            "&.Mui-selected": {
              color: "#1976d2",
              backgroundColor: "#e3f2fd",
              boxShadow: "0px 2px 6px rgba(25, 118, 210, 0.2)",
            },
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          },
        }}
      >
        <Tab label="📚 Additional Items" />
        <Tab label="➕ Added Items" />
        <Tab label="🧾 Bill Summary" />
      </Tabs>
    </Box>
  );
};




const headerCellStyle = {
  borderRight: "1px solid #ddd",
  padding: "2px",
  textAlign: "center",
  backgroundColor: "#fff9c4",
  fontWeight: "bold",
  fontSize: "14px",
};

const cellStyle = {
  textAlign: "center",
  borderRight: "1px solid #ddd",
  padding: "2px",
};





export default IndividualStudentsBooksList;
